<template>
	<div>
		<div class="ban">
			<swiper ref="mySwiper" :options="swiperOptions">
				<swiper-slide class='text2'>
					<div class="txt">
						<div class="w1200" v-html="$t('index1')">
							
						</div>
						
					</div>
					<img src="../../assets/img/111.jpg" alt="">
				</swiper-slide>
				<swiper-slide class='text4'>
					<div class="txt">
						<div class="w1200" v-html="$t('index2')">
							
						</div>
						
					</div>
					<img src="../../assets/img/222.jpg" alt="">
				</swiper-slide>
				<swiper-slide class='text3 text1'>
					<div class="txt" v-html="$t('index3')">
							
						</div>
					<img src="../../assets/img/333.jpg" alt="">
				</swiper-slide>
				
				
				<swiper-slide class='text1'>
					<div class="txt" v-html="$t('index4')">
							
						</div>
					<img src="../../assets/img/444.jpg" alt="">
				</swiper-slide>
				<div class="swiper-pagination" slot="pagination"></div>
			</swiper>
		</div>
		
		<div class="indexT ">
			{{$t('index5')}}
		</div>
		<div class="flor1">
			<div class="w1200">
				<x-row :gutter="0">
					<x-col class="col" span='8' xs="12">
						<div @click="natos('/jyjfz')">
							<img class="tp1" src="../../assets/img/service_icon2.png" alt="">
							<img class="tp2" src="../../assets/img/service_icon2-pressed.png" alt="">
							<p>RDL</p>
							{{$t('index6')}}
						</div>
					</x-col>
					<x-col class="col" span='8' xs="12">
						<div @click="natos('/jyjfz')">
							<img class="tp1" src="../../assets/img/service_icon3.png" alt="">
							<img class="tp2" src="../../assets/img/service_icon3-pressed.png" alt="">
							<p>CPB</p>
							{{$t('index7')}}
						</div>
					</x-col>
					
					<x-col class="col" span='8' xs="12">
						<div @click="natos('/jyjfz')">
							<img class="tp1" src="../../assets/img/service_icon4.png" alt="">
							<img class="tp2" src="../../assets/img/service_icon4-pressed.png" alt="">
							<p>LFB</p>
							{{$t('index8')}}
						</div>
					</x-col>
					<x-col class="col" span='8' xs="12">
						<div @click="natos('/dps')">
							<img class="tp1" src="../../assets/img/service_icon6.png" alt="">
							<img class="tp2" src="../../assets/img/service_icon6-pressed.png" alt="">
							<p>DPS</p>
							Die Processing Service
						</div>
					</x-col>
					<x-col class="col" span='8' xs="12">
						<div @click="natos('/csfw')">
							<img class="tp1" src="../../assets/img/service_icon5.png" alt="">
							<img class="tp2" src="../../assets/img/service_icon5-pressed.png" alt="">
							<p>CP Test</p>
							{{$t('index9')}}
						</div>
					</x-col>
					<x-col class="col" span='8' xs="12">
						<div @click="natos('/turnkey')">
							<img class="tp1" src="../../assets/img/service_icon7.png" alt="">
							<img class="tp2" src="../../assets/img/service_icon7-pressed.png" alt="">
							<p>Turnkey Service</p>
							{{$t('index10')}}
						</div>
					</x-col>
				</x-row>
			</div>

		</div>

		<!-- <div class="indexT indexT1">
			{{$t('jrwm')}}
		</div> -->
		<div class="joinus">
			<div class="w1340">
				<!--<div class="img">
					<div><img src="../../assets/img/jrwmsy.png" alt="">
					<a target="_blank" :href="$t('index12')"><img class="play" src="../../assets/img/play.png" alt=""></a>
					</div>
				</div>-->
				<video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
				<div class="nr" v-html="$t('index11')"></div>
			</div>
		</div>

		
	</div>
</template>

<script>
	import { videoPlayer } from 'vue-video-player'
	import 'video.js/dist/video-js.css'
	// import emailjs from 'emailjs-com' 
	// import apiKeys from './apikeys' 
	export default {
		name: 'carrousel',
		components: {
    		videoPlayer
  		},
		data() {
			return {
				playerOptions: {
            		playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
            		autoplay: false, // 如果为true,浏览器准备好时开始回放。
            		muted: false, // 默认情况下将会消除任何音频。
            		loop: false, // 是否视频一结束就重新开始。
            		preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
            		language: 'zh-CN',
            		aspectRatio: '21:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
            		fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
            		sources: [
						{type: "video/mp4", // 类型
              			src: require('../../assets/359486812-1-208.mp4') // url地址
           			 }],
            		poster: require('../../assets/img/jrwmsy.png'), // 封面地址
            		notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
            		controlBar: {
              			timeDivider: false, // 当前时间和持续时间的分隔符
              			durationDisplay: false, // 显示持续时间
              			remainingTimeDisplay: false, // 是否显示剩余时间功能
              			fullscreenToggle: true // 是否显示全屏按钮
            		}
          		},
				xwlist:[],
				swiperOptions: {
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
					effect: 'fade',
					autoplay: {
						delay: 6000,
						stopOnLastSlide: false,
						disableOnInteraction: false,
					},
				},
				
				newsOption: {
					slidesPerView: 3,
					spaceBetween: 30,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					breakpointsInverse: true,
					breakpoints: {
						300: { //当屏幕宽度大于等于300
							slidesPerView: 1,
							spaceBetween: 0
						},
						640: { //当屏幕宽度大于等于768
							slidesPerView: 2,
							spaceBetween: 15,
						},
						1000: { //当屏幕宽度大于等于1000
							slidesPerView: 3,
							spaceBetween: 30,
						}
					}
				},
			}
		},
		computed: {
			swiper() {
				return this.$refs.mySwiper.swiper
			},
			newss() {
				return this.$refs.news.swiper
			}
		},
		methods:{
			natos(e){
				var that=this
				that.$router.push(e)
			},
			nato(id){
				var that=this
				// that.$router.push('/slzj/lists/' + e)
				that.$router.push('/details?id='+id)
			}
		},
		created() {
			// pages(){
				var that=this
				that.$ajax({
					method: 'get',
					// url: 'http://www.koresemi.com/news_api/api/news/list?page=0&row=10',
					url: process.env.VUE_APP_SERVICE_URL + '/api/news/list?page=0&row=10',
					headers: {
						'Accept': '*/*',
						'Content-Type': 'application/json, text/plain, */*'
					},
				
				}).then(function(res) {
					that.xwlist=res.data.records
				 
				})
			// },
		}
	}
</script>
<style>
.video-player {
	width: 400px;
    height: 300px;
   	display: contents;
}
</style>
